export default "__VITE_ASSET__DNdLHkPi__"